import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { FinalAdsApiUrl } from '../../config';


export const adsContext = createContext();


const AdsContext = ({ children }) => {

  const [name, setName] = useState('Siddharth Dongre');


  // ---------- Campaign ----------

  const [showAdFinalPreviewPopup, setShowAdFinalPreviewPopup] = useState(false);

  const [ad, setAd] = useState({
    page: '',
    name: '',
    goal: '',
    description: '',

    categories: '',
    subCategories: '',

    headline: '',
    websiteDisplayLink: '',
    websiteRedirectUrl: '',
    media: [],
    mainText: '',

    savedAudience: '',
    locationSelection: 'radius',
    radiusLocation: [],
    customLocation: {
      country: '',
      state: '',
      cityInclude: '',
      cityExclude: '',
      minAge: '',
      maxAge: '',
      gender: 'all',
    },

    hobbies: '',
    occupation: '',
    placesVisited: '',

    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
    frequency: '',

    buttonType: 'action',
    buttonName: '',
    buttonLink: '',
  });


  // create Ad
  const createAd = () => {
    console.log('create : ', ad);
  };





  // ---------- Audience ----------

  const [audience, setAudience] = useState({
    name: '',
    locationSelection: 'radius',

    radiusLocations: [],

    customLocation: {
      country: '',
      state: '',
      cityInclude: '',
      cityExclude: '',
      minAge: '',
      maxAge: '',
      gender: 'all',
    },

    hobbies: '',
    occupation: '',
    placesVisited: '',

    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
    frequency: '',
  });

  // console.log('audience : ', audience);


  // create audience 
  const createAudience = () => {
    console.log('create : ', audience);

    axios.post(`${FinalAdsApiUrl}/createAudience`)
  };



  const value = {
    name, setName,

    // ---------- Campaign ----------

    ad, setAd,
    showAdFinalPreviewPopup, setShowAdFinalPreviewPopup,
    createAd,


    // ---------- Audience ----------

    audience, setAudience,
    createAudience,
  };

  return (<adsContext.Provider value={value}>{children}</adsContext.Provider>);
}

AdsContext.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdsContext;